module.exports = __webpack_public_path__ + "static/media/participant_list_format.c19a18fa.csv";